import { render, staticRenderFns } from "./yxfz.vue?vue&type=template&id=52f54d2c&scoped=true&"
import script from "./yxfz.vue?vue&type=script&lang=js&"
export * from "./yxfz.vue?vue&type=script&lang=js&"
import style0 from "./yxfz.vue?vue&type=style&index=0&id=52f54d2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f54d2c",
  null
  
)

export default component.exports